// Cross-site link to the Sophie marketing site.
// Defaults to a same-origin path so it works on the deployed `.replit.app`
// (where both sites live under one domain). Set VITE_SOPHIE_URL to an
// absolute URL once Sophie has its own custom domain.
export const SOPHIE_URL =
  (import.meta.env.VITE_SOPHIE_URL as string | undefined) ?? "/sophie/";
